import { render, staticRenderFns } from "./web_config.vue?vue&type=template&id=32d6cfc0&scoped=true&"
import script from "./web_config.vue?vue&type=script&lang=js&"
export * from "./web_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d6cfc0",
  null
  
)

export default component.exports